import React from 'react';
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import logo from '../../src/logo.svg'
import axiosInstance from '../axiosInstance'
import { withRouter } from 'react-router-dom'
import Alert from 'react-bootstrap/Alert'

class Login extends React.Component{

    constructor(props){
        super(props)
        this.state = {
            username:"",
            password:"",
            errors:{
                username:false,
                password:false,
                invalid:false,
            },
            error_messages:{
                username_message:'სახელი',
                password_message:'პაროლი',
                invalid_message:'მომხმარებლის სახელი ან პაროლი არასწორია'
            }
        }
        var token = localStorage.getItem('token');
        if(token !== null){
            this.props.history.push('/')
        }
    }

    onLogin(e,data){
        var token = data.data.token
        var role  = data.data.role
        var username = data.data.username
        localStorage.setItem('token',token);
        localStorage.setItem('role',role);
        localStorage.setItem('username',username)
        e.props.history.push("/");
    }
    login(e,event){
        event.preventDefault();

        if(this.valid()){
            var data = new FormData();
            data.append('username', e.state.username);
            data.append('password', e.state.password);
            data.append('action','login');
            
            axiosInstance.post("api.php",data)
            .then(data =>this.onLogin(e,data))
            .catch(err => {
                if(err.response.status === 400){
                    this.setState({
                        ...this.state, 
                        errors:{
                            ...this.state.errors,
                            invalid:true
                        }
                    })
                }
            })
        } 
    }

    onChange(event){
        this.setState({
            ...this.state,
            [event.target.name]:event.target.value,
            errors:{
                
                ...this.state.errors,
                [event.target.name]:false,
                invalid:false
            }
        })
    }
    valid(){
        var username = (this.state.username === '');
        var password = (this.state.password === '');
        if(username || password){
            this.setState({
                errors:{
                    ...this.state.errors,
                    username:username,
                    password:password, 
                },
            })
            return false;
        }
        return true;
    }
    render(){
        return (
            <div className="container container-login">
                <div className = "row login-row justify-content-center">
                    <div className = "col-sm-6">
                        <div className = "simple-login-container">
                            <div className = "row justify-content-center">
                                <img id="profile-img" className="img-fluid" src={logo} alt=""/>
                            </div>
                            <Form >
                                <Alert variant="danger" show={this.state.errors.invalid} className="alert">
                                    {this.state.error_messages.invalid_message}
                                </Alert>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Control 
                                        type="username" 
                                        name="username" 
                                        placeholder="მომხმარებელი" 
                                        onChange={(event)=>this.onChange(event)} 
                                        isInvalid={this.state.errors.username}
                                        />
                                    <Form.Control.Feedback type="invalid" >
                                        {this.state.error_messages.username_message}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formBasicPassword">
                                    <Form.Control 
                                        type="password" 
                                        name = "password" 
                                        placeholder="პაროლი" 
                                        onChange={(event)=>this.onChange(event)} 
                                        isInvalid={this.state.errors.password}
                                        />
                                    <Form.Control.Feedback type="invalid" >
                                        {this.state.error_messages.password_message}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Button variant="dark" type="submit" block="true" onClick= {(event)=>this.login(this,event)} >
                                    შესვლა
                                </Button>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(Login);